import React, { useEffect, useState, useContext } from "react";
import BoostHeader from "components/BoostHeader";
import PageHeaders from "common/PageHeaders";
import BoostFooter from "components/BoostFooter";
import BoostPopup from "components/BoostPopupModal";
import { BreakpointContext, PromoContext } from "components/common";
import { BoostCountDownBanner } from "@tomocredit/common-fe/components";
import PromoBanner from "components/PromoBanner";
import { useTimer } from "../../../components/common/wrappers/withTimer";
import { usePopup } from "../../../components/common/wrappers/withPopup";
import PricingContainer from "../PricingContainer";

const SHOW_POPUP_DELAY_SECONDS = 15;

const BoostContainer = ({
  children,
  relative = false,
  disablePopup = false,
  disableFooter = false,
  background = "default",
}) => {
  const { promoInfo } = useContext(PromoContext);
  const { isBelow } = useContext(BreakpointContext);
  const [popupOpen, setPopupOpen] = useState(false);
  const { seconds, startTimer, pauseTimer, stopTimer } = useTimer();
  const { hideExitPopupRef, hidePromoPopupRef, forceClosePromoPopupRef } = usePopup();
  const belowMd = isBelow("md");

  const closeModal = () => {
    stopTimer();
    setPopupOpen(false);
    forceClosePromoPopupRef.current = true;
  };

  // when user switch tab and back every time, open popup
  const handleVisibilityChange = () => {
    const newVisibilityStatus = document.visibilityState;
    if (newVisibilityStatus === "visible" && !disablePopup && !hidePromoPopupRef.current && !forceClosePromoPopupRef.current) {
      // user came back to the tab
      setPopupOpen(true);
    }
  };

  // document.activeElement does not work on Safari,
  // so we need to explicitly set by calling focus() on the element e.g. <a onClick={(e)=>e.currentTarget.focus();}/>
  const handleBeforeUnload = (e) => {
    const element = document.activeElement;
    if (
      !hideExitPopupRef.current &&
      !element.href?.startsWith(process.env.REACT_APP_DOMAIN) &&
      !element?.className?.includes("same-host-redirect")
    ) {
      e?.preventDefault();
    }
  };

  // start timer on boost container page loads
  useEffect(() => {
    startTimer();
    return () => pauseTimer();
  }, []);

  // open popup when timer reaches
  useEffect(() => {
    if (seconds >= SHOW_POPUP_DELAY_SECONDS && !disablePopup && !hidePromoPopupRef.current && !forceClosePromoPopupRef.current) {
      setPopupOpen(true);
    }
  }, [seconds >= SHOW_POPUP_DELAY_SECONDS]);

  useEffect(() => {
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // // show confirm popup when user try to exit the page
  // useEffect(() => {
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <>
      <PageHeaders type="boost" />
      <div className="flex flex-col h-full">
        <div
          className="xtopSection"
          id="outer-container"
          style={{ minWidth: "330px" }}
        >
          <div className={`headerBar ${relative ? "relative" : "fixed"}`}>
            {/* <PromoBanner /> */}
            <BoostHeader />
          </div>
          <BoostPopup isOpen={popupOpen} closeModal={closeModal} />  {/* Testing */}
          <div id="page-wrap">
            {promoInfo.showCountDown && (
              <BoostCountDownBanner
                text={promoInfo.text}
                deadline={promoInfo.deadline}
                belowMd={belowMd}
                showCountDown
                textClassName={belowMd ? "text-sm" : "text-md"}
              />
            )}
            {
              background === "pricing" ? (
                <PricingContainer>
                  {children}
                  {!disableFooter && <BoostFooter isBelow={isBelow} />}
                </PricingContainer>
              ) : (
                <>
                  {children}
                  {!disableFooter && <BoostFooter isBelow={isBelow} />}
                </>
              )
            }
          </div>
        </div>
        {/* this is to make the overflow section black */}
        <div className="w-screen h-screen bg-black fixed" style={{ zIndex: -1 }} />
      </div>
    </>
  );
};

export default BoostContainer;
